import React from "react";

interface LogoTextProps {
  className?: string;
}

export const LogoText: React.FC<LogoTextProps> = ({ className = "" }) => {
  return (
    <div className={`text-xl font-semibold ${className}`}>
      60Days{" "}
      <span className="text-heartRed inline-block animate-pulse-heart">❤️</span>
    </div>
  );
};
